var cov_1lrsia8x2o = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Transfer/Card.tsx",
      hash = "d89f44e5cffdbd77a7805c0f581ad0e4befce705",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Transfer/Card.tsx",
    statementMap: {
      "0": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 16
        }
      },
      "1": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 50
        }
      },
      "2": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 44
        }
      },
      "3": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 60
        }
      },
      "4": {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 31,
          column: 52
        }
      },
      "5": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 62
        }
      },
      "6": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "7": {
        start: {
          line: 41,
          column: 32
        },
        end: {
          line: 41,
          column: 42
        }
      },
      "8": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 44
        }
      },
      "9": {
        start: {
          line: 43,
          column: 32
        },
        end: {
          line: 43,
          column: 44
        }
      },
      "10": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 53
        }
      },
      "11": {
        start: {
          line: 45,
          column: 42
        },
        end: {
          line: 45,
          column: 53
        }
      },
      "12": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 26
        }
      },
      "13": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 24
        }
      },
      "14": {
        start: {
          line: 52,
          column: 25
        },
        end: {
          line: 52,
          column: 35
        }
      },
      "15": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 55,
          column: 5
        }
      },
      "16": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 36
        }
      },
      "17": {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 56,
          column: 48
        }
      },
      "18": {
        start: {
          line: 60,
          column: 60
        },
        end: {
          line: 60,
          column: 70
        }
      },
      "19": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 77,
          column: 5
        }
      },
      "20": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 74,
          column: 72
        }
      },
      "21": {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 73,
          column: 9
        }
      },
      "22": {
        start: {
          line: 67,
          column: 14
        },
        end: {
          line: 67,
          column: 39
        }
      },
      "23": {
        start: {
          line: 67,
          column: 31
        },
        end: {
          line: 67,
          column: 39
        }
      },
      "24": {
        start: {
          line: 68,
          column: 14
        },
        end: {
          line: 68,
          column: 42
        }
      },
      "25": {
        start: {
          line: 69,
          column: 14
        },
        end: {
          line: 69,
          column: 22
        }
      },
      "26": {
        start: {
          line: 74,
          column: 11
        },
        end: {
          line: 74,
          column: 72
        }
      },
      "27": {
        start: {
          line: 74,
          column: 50
        },
        end: {
          line: 74,
          column: 70
        }
      },
      "28": {
        start: {
          line: 76,
          column: 6
        },
        end: {
          line: 76,
          column: 29
        }
      },
      "29": {
        start: {
          line: 81,
          column: 64
        },
        end: {
          line: 81,
          column: 74
        }
      },
      "30": {
        start: {
          line: 82,
          column: 20
        },
        end: {
          line: 82,
          column: 37
        }
      },
      "31": {
        start: {
          line: 83,
          column: 16
        },
        end: {
          line: 83,
          column: 36
        }
      },
      "32": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 95,
          column: 5
        }
      },
      "33": {
        start: {
          line: 99,
          column: 47
        },
        end: {
          line: 99,
          column: 57
        }
      },
      "34": {
        start: {
          line: 100,
          column: 4
        },
        end: {
          line: 103,
          column: 5
        }
      },
      "35": {
        start: {
          line: 101,
          column: 6
        },
        end: {
          line: 101,
          column: 48
        }
      },
      "36": {
        start: {
          line: 102,
          column: 6
        },
        end: {
          line: 102,
          column: 12
        }
      },
      "37": {
        start: {
          line: 104,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "38": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 32
        }
      },
      "39": {
        start: {
          line: 110,
          column: 65
        },
        end: {
          line: 110,
          column: 75
        }
      },
      "40": {
        start: {
          line: 111,
          column: 36
        },
        end: {
          line: 111,
          column: 46
        }
      },
      "41": {
        start: {
          line: 112,
          column: 4
        },
        end: {
          line: 112,
          column: 29
        }
      },
      "42": {
        start: {
          line: 112,
          column: 18
        },
        end: {
          line: 112,
          column: 29
        }
      },
      "43": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 124,
          column: 5
        }
      },
      "44": {
        start: {
          line: 128,
          column: 56
        },
        end: {
          line: 128,
          column: 66
        }
      },
      "45": {
        start: {
          line: 129,
          column: 4
        },
        end: {
          line: 138,
          column: 5
        }
      },
      "46": {
        start: {
          line: 130,
          column: 21
        },
        end: {
          line: 136,
          column: 8
        }
      },
      "47": {
        start: {
          line: 137,
          column: 6
        },
        end: {
          line: 137,
          column: 31
        }
      },
      "48": {
        start: {
          line: 137,
          column: 18
        },
        end: {
          line: 137,
          column: 31
        }
      },
      "49": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 32
        }
      },
      "50": {
        start: {
          line: 144,
          column: 78
        },
        end: {
          line: 144,
          column: 88
        }
      },
      "51": {
        start: {
          line: 145,
          column: 4
        },
        end: {
          line: 145,
          column: 43
        }
      },
      "52": {
        start: {
          line: 145,
          column: 32
        },
        end: {
          line: 145,
          column: 43
        }
      },
      "53": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 158,
          column: 5
        }
      },
      "54": {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 157,
          column: 7
        }
      },
      "55": {
        start: {
          line: 159,
          column: 4
        },
        end: {
          line: 169,
          column: 5
        }
      },
      "56": {
        start: {
          line: 185,
          column: 8
        },
        end: {
          line: 185,
          column: 18
        }
      },
      "57": {
        start: {
          line: 187,
          column: 18
        },
        end: {
          line: 187,
          column: 36
        }
      },
      "58": {
        start: {
          line: 188,
          column: 20
        },
        end: {
          line: 188,
          column: 37
        }
      },
      "59": {
        start: {
          line: 189,
          column: 19
        },
        end: {
          line: 189,
          column: 71
        }
      },
      "60": {
        start: {
          line: 190,
          column: 4
        },
        end: {
          line: 214,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 26,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        loc: {
          start: {
            line: 26,
            column: 49
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 26
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 16
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 40
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 37
          },
          end: {
            line: 57,
            column: 3
          }
        },
        line: 50
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 24
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 59
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 66,
            column: 12
          },
          end: {
            line: 66,
            column: 13
          }
        },
        loc: {
          start: {
            line: 66,
            column: 25
          },
          end: {
            line: 70,
            column: 13
          }
        },
        line: 66
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 74,
            column: 40
          },
          end: {
            line: 74,
            column: 41
          }
        },
        loc: {
          start: {
            line: 74,
            column: 50
          },
          end: {
            line: 74,
            column: 70
          }
        },
        line: 74
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        loc: {
          start: {
            line: 80,
            column: 43
          },
          end: {
            line: 96,
            column: 3
          }
        },
        line: 80
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 98,
            column: 2
          },
          end: {
            line: 98,
            column: 3
          }
        },
        loc: {
          start: {
            line: 98,
            column: 58
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 98
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 19
          },
          end: {
            line: 125,
            column: 3
          }
        },
        line: 109
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 127,
            column: 2
          },
          end: {
            line: 127,
            column: 3
          }
        },
        loc: {
          start: {
            line: 127,
            column: 15
          },
          end: {
            line: 141,
            column: 3
          }
        },
        line: 127
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 143,
            column: 2
          },
          end: {
            line: 143,
            column: 3
          }
        },
        loc: {
          start: {
            line: 143,
            column: 17
          },
          end: {
            line: 170,
            column: 3
          }
        },
        line: 143
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 172,
            column: 2
          },
          end: {
            line: 172,
            column: 3
          }
        },
        loc: {
          start: {
            line: 172,
            column: 11
          },
          end: {
            line: 215,
            column: 3
          }
        },
        line: 172
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 44
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 43,
            column: 44
          }
        }],
        line: 43
      },
      "1": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 53
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 45,
            column: 53
          }
        }],
        line: 45
      },
      "2": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 55,
            column: 5
          }
        }],
        line: 53
      },
      "3": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        }],
        line: 61
      },
      "4": {
        loc: {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 74,
            column: 72
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 74,
            column: 72
          }
        }, {
          start: {
            line: 62,
            column: 6
          },
          end: {
            line: 74,
            column: 72
          }
        }],
        line: 62
      },
      "5": {
        loc: {
          start: {
            line: 67,
            column: 14
          },
          end: {
            line: 67,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 14
          },
          end: {
            line: 67,
            column: 39
          }
        }, {
          start: {
            line: 67,
            column: 14
          },
          end: {
            line: 67,
            column: 39
          }
        }],
        line: 67
      },
      "6": {
        loc: {
          start: {
            line: 89,
            column: 18
          },
          end: {
            line: 89,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 89,
            column: 18
          },
          end: {
            line: 89,
            column: 25
          }
        }, {
          start: {
            line: 89,
            column: 30
          },
          end: {
            line: 89,
            column: 60
          }
        }, {
          start: {
            line: 89,
            column: 64
          },
          end: {
            line: 89,
            column: 75
          }
        }],
        line: 89
      },
      "7": {
        loc: {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }, {
          start: {
            line: 100,
            column: 4
          },
          end: {
            line: 103,
            column: 5
          }
        }],
        line: 100
      },
      "8": {
        loc: {
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 100,
            column: 33
          }
        }, {
          start: {
            line: 100,
            column: 37
          },
          end: {
            line: 100,
            column: 62
          }
        }],
        line: 100
      },
      "9": {
        loc: {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }, {
          start: {
            line: 104,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }],
        line: 104
      },
      "10": {
        loc: {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 29
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 29
          }
        }, {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 112,
            column: 29
          }
        }],
        line: 112
      },
      "11": {
        loc: {
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 138,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 138,
            column: 5
          }
        }, {
          start: {
            line: 129,
            column: 4
          },
          end: {
            line: 138,
            column: 5
          }
        }],
        line: 129
      },
      "12": {
        loc: {
          start: {
            line: 132,
            column: 19
          },
          end: {
            line: 132,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 132,
            column: 33
          },
          end: {
            line: 132,
            column: 39
          }
        }, {
          start: {
            line: 132,
            column: 42
          },
          end: {
            line: 132,
            column: 49
          }
        }],
        line: 132
      },
      "13": {
        loc: {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 137,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 137,
            column: 31
          }
        }, {
          start: {
            line: 137,
            column: 6
          },
          end: {
            line: 137,
            column: 31
          }
        }],
        line: 137
      },
      "14": {
        loc: {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 145,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 145,
            column: 43
          }
        }, {
          start: {
            line: 145,
            column: 4
          },
          end: {
            line: 145,
            column: 43
          }
        }],
        line: 145
      },
      "15": {
        loc: {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 145,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 145,
            column: 17
          }
        }, {
          start: {
            line: 145,
            column: 21
          },
          end: {
            line: 145,
            column: 30
          }
        }],
        line: 145
      },
      "16": {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        }, {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 158,
            column: 5
          }
        }],
        line: 146
      },
      "17": {
        loc: {
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 146,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 146,
            column: 8
          },
          end: {
            line: 146,
            column: 20
          }
        }, {
          start: {
            line: 146,
            column: 24
          },
          end: {
            line: 146,
            column: 58
          }
        }],
        line: 146
      },
      "18": {
        loc: {
          start: {
            line: 195,
            column: 15
          },
          end: {
            line: 195,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 195,
            column: 23
          },
          end: {
            line: 195,
            column: 69
          }
        }, {
          start: {
            line: 195,
            column: 72
          },
          end: {
            line: 195,
            column: 94
          }
        }],
        line: 195
      },
      "19": {
        loc: {
          start: {
            line: 205,
            column: 15
          },
          end: {
            line: 207,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 205,
            column: 15
          },
          end: {
            line: 205,
            column: 36
          }
        }, {
          start: {
            line: 205,
            column: 40
          },
          end: {
            line: 205,
            column: 57
          }
        }, {
          start: {
            line: 206,
            column: 16
          },
          end: {
            line: 206,
            column: 92
          }
        }],
        line: 205
      },
      "20": {
        loc: {
          start: {
            line: 206,
            column: 57
          },
          end: {
            line: 206,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 206,
            column: 57
          },
          end: {
            line: 206,
            column: 62
          }
        }, {
          start: {
            line: 206,
            column: 66
          },
          end: {
            line: 206,
            column: 85
          }
        }],
        line: 206
      },
      "21": {
        loc: {
          start: {
            line: 212,
            column: 9
          },
          end: {
            line: 212,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 212,
            column: 9
          },
          end: {
            line: 212,
            column: 15
          }
        }, {
          start: {
            line: 212,
            column: 19
          },
          end: {
            line: 212,
            column: 97
          }
        }],
        line: 212
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0],
      "20": [0, 0],
      "21": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Transfer/Card.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import Spin from '../Spin';
import filter from './filter';
import SCard from '../Card';
import Checkbox from '../Checkbox';
import { PureComponent } from '../component';
import { transferClass } from './styles';
import { getKey } from '../utils/uid';
import { createFunc } from '../utils/func';
import { isFunc } from '../utils/is';
import Item from './item';
import LazyList from '../AnimationList/LazyList';
import { getLocale } from '../locale';
import Input from '../Input';

var Card =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Card, _PureComponent);

  var _super = _createSuper2(Card);

  function Card(props) {
    var _this;

    _classCallCheck(this, Card);

    cov_1lrsia8x2o.f[0]++;
    cov_1lrsia8x2o.s[0]++;
    _this = _super.call(this, props);
    _this.cardBody = void 0;
    cov_1lrsia8x2o.s[1]++;
    _this.getCheckAll = _this.getCheckAll.bind(_assertThisInitialized(_this));
    cov_1lrsia8x2o.s[2]++;
    _this.checkAll = _this.checkAll.bind(_assertThisInitialized(_this));
    cov_1lrsia8x2o.s[3]++;
    _this.handleRenderItem = _this.handleRenderItem.bind(_assertThisInitialized(_this));
    cov_1lrsia8x2o.s[4]++;
    _this.bindCardBody = _this.bindCardBody.bind(_assertThisInitialized(_this));
    cov_1lrsia8x2o.s[5]++;
    _this.customSetSelected = _this.customSetSelected.bind(_assertThisInitialized(_this));
    cov_1lrsia8x2o.s[6]++;
    _this.state = {
      listHeight: props.listHeight,
      mounted: false
    };
    return _this;
  }

  _createClass(Card, [{
    key: "getCheckAll",
    value: function getCheckAll() {
      cov_1lrsia8x2o.f[1]++;

      var _ref = (cov_1lrsia8x2o.s[7]++, this.props),
          selecteds = _ref.selecteds,
          data = _ref.data;

      cov_1lrsia8x2o.s[8]++;

      if (selecteds.length === 0) {
        cov_1lrsia8x2o.b[0][0]++;
        cov_1lrsia8x2o.s[9]++;
        return false;
      } else {
        cov_1lrsia8x2o.b[0][1]++;
      }

      cov_1lrsia8x2o.s[10]++;

      if (selecteds.length === data.length) {
        cov_1lrsia8x2o.b[1][0]++;
        cov_1lrsia8x2o.s[11]++;
        return true;
      } else {
        cov_1lrsia8x2o.b[1][1]++;
      }

      cov_1lrsia8x2o.s[12]++;
      return 'indeterminate';
    }
  }, {
    key: "bindCardBody",
    value: function bindCardBody(node) {
      cov_1lrsia8x2o.f[2]++;
      cov_1lrsia8x2o.s[13]++;
      this.cardBody = node;

      var _ref2 = (cov_1lrsia8x2o.s[14]++, this.props),
          listHeight = _ref2.listHeight;

      cov_1lrsia8x2o.s[15]++;

      if (node) {
        cov_1lrsia8x2o.b[2][0]++;
        cov_1lrsia8x2o.s[16]++;
        listHeight = node.offsetHeight;
      } else {
        cov_1lrsia8x2o.b[2][1]++;
      }

      cov_1lrsia8x2o.s[17]++;
      this.setState({
        listHeight: listHeight,
        mounted: true
      });
    }
  }, {
    key: "checkAll",
    value: function checkAll(c) {
      cov_1lrsia8x2o.f[3]++;

      var _ref3 = (cov_1lrsia8x2o.s[18]++, this.props),
          setSelecteds = _ref3.setSelecteds,
          index = _ref3.index,
          data = _ref3.data,
          keygen = _ref3.keygen,
          disabled = _ref3.disabled;

      cov_1lrsia8x2o.s[19]++;

      if (c) {
        cov_1lrsia8x2o.b[3][0]++;
        cov_1lrsia8x2o.s[20]++;

        if (typeof disabled === 'function') {
          cov_1lrsia8x2o.b[4][0]++;
          cov_1lrsia8x2o.s[21]++;
          setSelecteds(index, data.reduce(function (r, d, i) {
            cov_1lrsia8x2o.f[4]++;
            cov_1lrsia8x2o.s[22]++;

            if (disabled(d)) {
              cov_1lrsia8x2o.b[5][0]++;
              cov_1lrsia8x2o.s[23]++;
              return r;
            } else {
              cov_1lrsia8x2o.b[5][1]++;
            }

            cov_1lrsia8x2o.s[24]++;
            r.push(getKey(d, keygen, i));
            cov_1lrsia8x2o.s[25]++;
            return r;
          }, []));
        } else {
          cov_1lrsia8x2o.b[4][1]++;
          cov_1lrsia8x2o.s[26]++;
          setSelecteds(index, data.map(function (d, i) {
            cov_1lrsia8x2o.f[5]++;
            cov_1lrsia8x2o.s[27]++;
            return getKey(d, keygen, i);
          }));
        }
      } else {
        cov_1lrsia8x2o.b[3][1]++;
        cov_1lrsia8x2o.s[28]++;
        setSelecteds(index, []);
      }
    }
  }, {
    key: "handleRenderItem",
    value: function handleRenderItem(d, i) {
      cov_1lrsia8x2o.f[6]++;

      var _ref4 = (cov_1lrsia8x2o.s[29]++, this.props),
          keygen = _ref4.keygen,
          index = _ref4.index,
          renderItem = _ref4.renderItem,
          disabled = _ref4.disabled,
          lineHeight = _ref4.lineHeight;

      var disable = (cov_1lrsia8x2o.s[30]++, disabled === true);
      var key = (cov_1lrsia8x2o.s[31]++, getKey(d, keygen, i));
      cov_1lrsia8x2o.s[32]++;
      return (
        /*#__PURE__*/
        React.createElement(Item, {
          lineHeight: lineHeight,
          key: key,
          disabled: (cov_1lrsia8x2o.b[6][0]++, disable) || (cov_1lrsia8x2o.b[6][1]++, typeof disabled === 'function') && (cov_1lrsia8x2o.b[6][2]++, disabled(d)),
          index: index,
          checkKey: key,
          liData: d,
          content: createFunc(renderItem)(d),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 86,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "customSetSelected",
    value: function customSetSelected(value) {
      cov_1lrsia8x2o.f[7]++;

      var _ref5 = (cov_1lrsia8x2o.s[33]++, this.props),
          index = _ref5.index,
          setSelecteds = _ref5.setSelecteds,
          selecteds = _ref5.selecteds;

      cov_1lrsia8x2o.s[34]++;

      if ((cov_1lrsia8x2o.b[8][0]++, typeof value === 'string') || (cov_1lrsia8x2o.b[8][1]++, typeof value === 'number')) {
        cov_1lrsia8x2o.b[7][0]++;
        cov_1lrsia8x2o.s[35]++;
        setSelecteds(index, [].concat(_toConsumableArray(selecteds), [value]));
        cov_1lrsia8x2o.s[36]++;
        return;
      } else {
        cov_1lrsia8x2o.b[7][1]++;
      }

      cov_1lrsia8x2o.s[37]++;

      if (Array.isArray(value)) {
        cov_1lrsia8x2o.b[9][0]++;
        cov_1lrsia8x2o.s[38]++;
        setSelecteds(index, value);
      } else {
        cov_1lrsia8x2o.b[9][1]++;
      }
    }
  }, {
    key: "renderLazyList",
    value: function renderLazyList() {
      cov_1lrsia8x2o.f[8]++;

      var _ref6 = (cov_1lrsia8x2o.s[39]++, this.props),
          filterText = _ref6.filterText,
          data = _ref6.data,
          rowsInView = _ref6.rowsInView,
          lineHeight = _ref6.lineHeight,
          keygen = _ref6.keygen;

      var _ref7 = (cov_1lrsia8x2o.s[40]++, this.state),
          mounted = _ref7.mounted,
          listHeight = _ref7.listHeight;

      cov_1lrsia8x2o.s[41]++;

      if (!mounted) {
        cov_1lrsia8x2o.b[10][0]++;
        cov_1lrsia8x2o.s[42]++;
        return null;
      } else {
        cov_1lrsia8x2o.b[10][1]++;
      }

      cov_1lrsia8x2o.s[43]++;
      return (
        /*#__PURE__*/
        React.createElement(LazyList, {
          stay: !filterText,
          data: data,
          itemsInView: rowsInView,
          lineHeight: lineHeight,
          height: listHeight,
          keygen: keygen // scrollHeight={lineHeight * data.length}
          ,
          renderItem: this.handleRenderItem,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 114,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      cov_1lrsia8x2o.f[9]++;

      var _ref8 = (cov_1lrsia8x2o.s[44]++, this.props),
          customRender = _ref8.customRender,
          index = _ref8.index,
          values = _ref8.values,
          filterText = _ref8.filterText;

      cov_1lrsia8x2o.s[45]++;

      if (isFunc(customRender)) {
        cov_1lrsia8x2o.b[11][0]++;
        var custom = (cov_1lrsia8x2o.s[46]++, customRender({
          onSelected: this.customSetSelected,
          direction: index === 0 ? (cov_1lrsia8x2o.b[12][0]++, 'left') : (cov_1lrsia8x2o.b[12][1]++, 'right'),
          selectedKeys: this.props.selecteds,
          value: values,
          filterText: filterText
        }));
        cov_1lrsia8x2o.s[47]++;

        if (custom) {
          cov_1lrsia8x2o.b[13][0]++;
          cov_1lrsia8x2o.s[48]++;
          return custom;
        } else {
          cov_1lrsia8x2o.b[13][1]++;
        }
      } else {
        cov_1lrsia8x2o.b[11][1]++;
      }

      cov_1lrsia8x2o.s[49]++;
      return this.renderLazyList();
    }
  }, {
    key: "renderFilter",
    value: function renderFilter() {
      cov_1lrsia8x2o.f[10]++;

      var _ref9 = (cov_1lrsia8x2o.s[50]++, this.props),
          onFilter = _ref9.onFilter,
          onSearch = _ref9.onSearch,
          renderFilter = _ref9.renderFilter,
          filterText = _ref9.filterText,
          disabled = _ref9.disabled,
          index = _ref9.index;

      cov_1lrsia8x2o.s[51]++;

      if ((cov_1lrsia8x2o.b[15][0]++, !onFilter) && (cov_1lrsia8x2o.b[15][1]++, !onSearch)) {
        cov_1lrsia8x2o.b[14][0]++;
        cov_1lrsia8x2o.s[52]++;
        return null;
      } else {
        cov_1lrsia8x2o.b[14][1]++;
      }

      cov_1lrsia8x2o.s[53]++;

      if ((cov_1lrsia8x2o.b[17][0]++, renderFilter) && (cov_1lrsia8x2o.b[17][1]++, typeof renderFilter === 'function')) {
        cov_1lrsia8x2o.b[16][0]++;
        cov_1lrsia8x2o.s[54]++;
        return (
          /*#__PURE__*/
          React.createElement("div", {
            className: transferClass('filter'),
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 148,
              columnNumber: 9
            }
          }, renderFilter({
            value: filterText,
            disabled: disabled === true,
            onFilter: onFilter,
            placeholder: getLocale('search'),
            isSource: index === 0
          }))
        );
      } else {
        cov_1lrsia8x2o.b[16][1]++;
      }

      cov_1lrsia8x2o.s[55]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('filter'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 160,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Input, {
          disabled: disabled === true,
          onChange: onFilter,
          placeholder: getLocale('search'),
          clearable: true,
          value: filterText,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 161,
            columnNumber: 9
          }
        }))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_1lrsia8x2o.f[11]++;

      var _ref10 = (cov_1lrsia8x2o.s[56]++, this.props),
          title = _ref10.title,
          data = _ref10.data,
          selecteds = _ref10.selecteds,
          footer = _ref10.footer,
          listClassName = _ref10.listClassName,
          listStyle = _ref10.listStyle,
          empty = _ref10.empty,
          disabled = _ref10.disabled,
          loading = _ref10.loading,
          listHeight = _ref10.listHeight,
          customRender = _ref10.customRender;

      var check = (cov_1lrsia8x2o.s[57]++, this.getCheckAll());
      var disable = (cov_1lrsia8x2o.s[58]++, disabled === true);
      var listms = (cov_1lrsia8x2o.s[59]++, Object.assign({}, listStyle, {
        height: listHeight
      }));
      cov_1lrsia8x2o.s[60]++;
      return (
        /*#__PURE__*/
        React.createElement(SCard, {
          className: transferClass('card'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 191,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(SCard.Header, {
          className: transferClass('card-header'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 192,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 193,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement(Checkbox, {
          onChange: this.checkAll,
          checked: check,
          disabled: disable,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 194,
            columnNumber: 13
          }
        }, check ? (cov_1lrsia8x2o.b[18][0]++, "".concat(selecteds.length, " ").concat(getLocale('selected'))) : (cov_1lrsia8x2o.b[18][1]++, getLocale('selectAll')))),
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('card-header-title'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 198,
            columnNumber: 11
          }
        }, title)), this.renderFilter(),
        /*#__PURE__*/
        React.createElement(Spin, {
          loading: loading,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 201,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(SCard.Body, {
          className: classnames(transferClass('card-body'), listClassName),
          style: listms,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 202,
            columnNumber: 11
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('body-container'),
          ref: this.bindCardBody,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 203,
            columnNumber: 13
          }
        }, this.renderBody(), (cov_1lrsia8x2o.b[19][0]++, !isFunc(customRender)) && (cov_1lrsia8x2o.b[19][1]++, data.length === 0) && (cov_1lrsia8x2o.b[19][2]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: transferClass('empty'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 206,
            columnNumber: 17
          }
        }, (cov_1lrsia8x2o.b[20][0]++, empty) || (cov_1lrsia8x2o.b[20][1]++, getLocale('noData'))))))), (cov_1lrsia8x2o.b[21][0]++, footer) && (cov_1lrsia8x2o.b[21][1]++,
        /*#__PURE__*/
        React.createElement(SCard.Footer, {
          className: transferClass('card-footer'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 212,
            columnNumber: 20
          }
        }, footer)))
      );
    }
  }]);

  return Card;
}(PureComponent);

export default filter(Card);